import { useState, useContext } from 'react';
import { isJsonString } from '../../../../../utilities/helpers';
import JSONPretty from 'react-json-pretty';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import { validGamUprFloorValues } from '../../../../../core/constants/gamUprConstants';
import { countryCodesList } from '../../../../../core/constants';
import { isCountryWiseFloorObjectValid } from '../../../../../utilities/helpers';
//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import useCommonStyles from '../../../../../commonStyles';
import TextField from '@mui/material/TextField';
import { Grid, Button, Typography } from '@mui/material';
import { toast } from 'react-toastify';
//===============

const GamUprJson = ({ keyData, platform, operatingSystem }) => {
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();
	const [gamUprJsonInput, setGamUprJsonInput] = useState('');
	const [percentageChange, setPercentageChange] = useState('');
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const gamUprPlatformObject =
		rawConfig[keyData]?.[platform]?.[operatingSystem]?.countryWiseFloorMapping || {};

	/**
	 * @name handleUpdate
	 * @description The function validates the platform object if all country keys and floor are valid and updates it to the rawConfig
	 */

	const handleUpdate = () => {
		if (!isJsonString(gamUprJsonInput)) {
			alert('Not a JSON object');
			return;
		}
		const parsedJson = JSON.parse(gamUprJsonInput);

		const gamUprValidatorData = {
			countryWiseFloorObject: parsedJson,
			countryCodesList,
			validGamUprFloorValues,
			gamUprPlatform: platform,
			videoSectionId: rawConfig && rawConfig['videoSectionId'],
			gamUprOperatingSystem: operatingSystem
		};
		try {
			isCountryWiseFloorObjectValid(gamUprValidatorData);

			let updatedObject = structuredClone(rawConfig);
			updatedObject[keyData][platform][operatingSystem].countryWiseFloorMapping = parsedJson;
			updateRawConfig(updatedObject);
			setGamUprJsonInput('');
			alert('Gam Upr Object Updated ');
		} catch (err) {
			alert(err.message);
			console.error(err);
		}
	};

	/**
	 * @name handleChecks
	 * @param {String} percentFirstCharacter first character of the percentageChange
	 * @param {Number} percentValue Numeric value after first character of the percentageChange string
	 * @description The function validates the input percentageChange value and return true if passes the checks
	 * @returns {Boolean} return true if the input values are valid
	 */
	function handleChecks(percentFirstCharacter, percentValue) {
		let areValuesValid = true;
		if (percentFirstCharacter !== '+' && percentFirstCharacter !== '-') {
			areValuesValid = false;
		}

		if (
			isNaN(percentValue) ||
			typeof percentValue !== 'number' ||
			percentValue < -100 ||
			percentValue > 100
		) {
			areValuesValid = false;
		}
		return areValuesValid;
	}

	/**
	 * @name getNearbyFloor
	 * @param {Number} updatedValue PercentValue by which all the floors will be change
	 * @param {Array} floorValues defaultGamUpr floor list
	 * @description The function takes the calculated value and set it to nearby floors from floorvalues
	 * @returns {Number} Nearest Value to floorValues list.
	 */

	function getNearbyFloor(updatedValue, floorValues) {
		let nearestFloor = floorValues[0];
		for (const floor of floorValues) {
			const numericUpdatedValue = updatedValue;
			const numericFloor = parseFloat(floor);

			if (
				Math.abs(numericUpdatedValue - numericFloor) <
				Math.abs(numericUpdatedValue - parseFloat(nearestFloor))
			) {
				nearestFloor = floor;
			}
		}

		return nearestFloor;
	}
	/**
	 * @name handlePercentageChange
	 * @description The function takes the percentageChange value and calculated the updatedvalue and set it to nearby floors from floorvalues and setGamUprJsonInput
	 */
	const handlePercentageChange = () => {
		let incrementFloorValue;
		let percentFirstCharacter = percentageChange.substring(0, 1);
		let percentValue = parseFloat(percentageChange.substring(1));
		if (!handleChecks(percentFirstCharacter, percentValue)) {
			toast.error(
				"Invalid Value or format, use '+' or '-' before value and range should be between -100 to +100",
				{ position: toast.POSITION.BOTTOM_RIGHT }
			);
			return;
		}
		percentFirstCharacter === '+' ? (incrementFloorValue = true) : (incrementFloorValue = false);
		const newFloorObject = { ...gamUprPlatformObject };
		Object.keys(newFloorObject).forEach((key) => {
			const value = parseFloat(newFloorObject[key]);
			let updatedValue = incrementFloorValue
				? value + (value / 100) * percentValue
				: value - (value / 100) * percentValue;
			let nearbyFloorValue = getNearbyFloor(updatedValue, validGamUprFloorValues);
			newFloorObject[key] = nearbyFloorValue;
		});
		setGamUprJsonInput(JSON.stringify(newFloorObject, null, 2));
	};

	return (
		<Box className={classes.gamUprConfig}>
			<Grid container spacing={2}>
				<Grid item xs={3}>
					<TextField
						id="percentage-change"
						value={percentageChange}
						label="Enter Floor Percent"
						onChange={(e) => setPercentageChange(e.target.value)}
					/>
				</Grid>
				<Grid item xs={5}>
					<Button
						variant="contained"
						style={{ marginTop: '1rem', marginBottom: '2rem' }}
						onClick={handlePercentageChange}
					>
						Show Floor change
					</Button>
				</Grid>
			</Grid>

			<Grid container spacing={2} style={{ marginTop: '1.5rem' }}>
				<Grid item xs={6}>
					<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
						Current
					</Typography>
					<Box className={classes.gamUprJsonOutput}>
						<JSONPretty id="json-pretty" data={gamUprPlatformObject}></JSONPretty>
					</Box>
				</Grid>
				<Grid item xs={6}>
					<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
						Input
					</Typography>
					<TextField
						id="outlined-multiline-static"
						multiline
						value={gamUprJsonInput}
						onChange={(e) => setGamUprJsonInput(e.target.value)}
						className={classes.gamUprJsonInput}
						maxRows={20}
						minRows={20}
					/>
				</Grid>
				<Grid
					item
					xs={12}
					style={{
						display: 'flex',
						justifyContent: 'center'
					}}
				>
					<Button
						variant="contained"
						style={{ marginTop: '2rem', marginBottom: '2rem' }}
						onClick={handleUpdate}
					>
						Update
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
};
export default GamUprJson;
